import React from "react";

import {DateString} from "@globals/types/utilityTypes";

import NomiconIcon from "@components/NomiconIcon";

import styles from "./SeeMenuLink.scss";

export default function SeeMenuLink({
  dailyMenuDate,
  linkLabel,
}: {
  dailyMenuDate: DateString;
  linkLabel: string;
}): JSX.Element {
  return (
    <a
      className={styles.link}
      href={`/menu/?date=${dailyMenuDate}`}
      data-testid="see-menu-link"
    >
      <NomiconIcon className={styles.linkIcon} icon="nomicon-long-arrow-left" />
      <span className={styles.linkText}>{linkLabel}</span>
    </a>
  );
}
